
import '../styles/theme.css';

export default function PolitiqueConfidentialite() {
    return (
        <>
            <div className="container" style={{ padding: '60px 20px', maxWidth: '800px' }}>
                <h1 style={{ marginBottom: '40px', fontSize: '32px', borderBottom: '2px solid var(--accent)', display: 'inline-block', paddingBottom: '10px' }}>
                    Politique de Confidentialité
                </h1>

                <section style={{ marginBottom: '32px' }}>
                    <h2 style={{ fontSize: '20px', color: 'var(--accent-600)', marginBottom: '16px' }}>1. Introduction</h2>
                    <p style={{ lineHeight: '1.6', color: '#374151' }}>
                        La société <strong>AEF32</strong> accorde une importance primordiale à la protection de vos données personnelles.
                        Cette politique de confidentialité vous informe sur la manière dont nous collectons, utilisons et protégeons vos données lorsque vous utilisez notre site web.
                    </p>
                </section>

                <section style={{ marginBottom: '32px' }}>
                    <h2 style={{ fontSize: '20px', color: 'var(--accent-600)', marginBottom: '16px' }}>2. Collecte des données</h2>
                    <p style={{ lineHeight: '1.6', color: '#374151' }}>
                        Nous collectons les informations que vous nous communiquez directement, notamment :
                    </p>
                    <ul style={{ paddingLeft: '20px', lineHeight: '1.8', color: '#374151' }}>
                        <li>Via le formulaire de contact (nom, email, téléphone, sujet du message).</li>
                        <li>Lors de la création d'un compte client.</li>
                        <li>Lors de l'utilisation de la fonction "Favoris" (stockage local et synchronisation si connecté).</li>
                    </ul>
                </section>

                <section style={{ marginBottom: '32px' }}>
                    <h2 style={{ fontSize: '20px', color: 'var(--accent-600)', marginBottom: '16px' }}>3. Utilisation des données</h2>
                    <p style={{ lineHeight: '1.6', color: '#374151' }}>
                        Vos données sont utilisées pour :
                    </p>
                    <ul style={{ paddingLeft: '20px', lineHeight: '1.8', color: '#374151' }}>
                        <li>Répondre à vos demandes de renseignements ou de devis.</li>
                        <li>Gérer votre compte client et vos favoris.</li>
                        <li>Améliorer l'expérience utilisateur sur notre site.</li>
                    </ul>
                </section>

                <section style={{ marginBottom: '32px' }}>
                    <h2 style={{ fontSize: '20px', color: 'var(--accent-600)', marginBottom: '16px' }}>4. Conservation des données</h2>
                    <p style={{ lineHeight: '1.6', color: '#374151' }}>
                        Nous conservons vos données uniquement le temps nécessaire aux finalités pour lesquelles elles ont été collectées,
                        conformément aux obligations légales en vigueur.
                    </p>
                </section>

                <section style={{ marginBottom: '32px' }}>
                    <h2 style={{ fontSize: '20px', color: 'var(--accent-600)', marginBottom: '16px' }}>5. Vos droits</h2>
                    <p style={{ lineHeight: '1.6', color: '#374151' }}>
                        Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez d'un droit d'accès,
                        de rectification, de suppression et d'opposition au traitement de vos données personnelles.
                    </p>
                    <p style={{ lineHeight: '1.6', color: '#374151', marginTop: '10px' }}>
                        Pour exercer ces droits, vous pouvez nous contacter à l'adresse suivante :<br />
                        <strong>2 CHEMIN DES RELIGIEUSES, 32220 LOMBEZ</strong> ou via notre formulaire de contact.
                    </p>
                </section>

                <section style={{ marginBottom: '32px' }}>
                    <h2 style={{ fontSize: '20px', color: 'var(--accent-600)', marginBottom: '16px' }}>6. Cookies</h2>
                    <p style={{ lineHeight: '1.6', color: '#374151' }}>
                        Notre site peut utiliser des cookies pour améliorer votre navigation. Vous pouvez configurer votre navigateur pour refuser ces cookies,
                        bien que cela puisse affecter certaines fonctionnalités du site.
                    </p>
                </section>
            </div>
        </>
    );
}
